import { createAsyncThunk } from '@reduxjs/toolkit';
import API_BASE_URL from '../../config/api';
import axios from 'axios';

export const fetchContestStats = createAsyncThunk(
  'contest/fetchStats',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth: { token } } = getState();

      if (!token) {
        return rejectWithValue('No authentication token, authorization denied');
      }

      const response = await axios.get(`${API_BASE_URL}/contest/stats`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch stats');
    }
  }
);

export const fetchDailyContent = createAsyncThunk(
  'contest/fetchDailyContent',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth: { token } } = getState();
      if (!token) {
        return rejectWithValue('No authentication token, authorization denied');
      }
      const response = await axios.get(`${API_BASE_URL}/contest/daily-content`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch daily content');
    }
  }
);

export const submitDailyPhotoContestGuess = createAsyncThunk(
  'contest/submitDailyPhotoContestGuess',
  async (guess, { rejectWithValue, getState }) => {
    try {
      const { auth: { token } } = getState();
      if (!token) {
        return rejectWithValue('No authentication token, authorization denied');
      }
      const response = await axios.post(`${API_BASE_URL}/contest/guess`, guess, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch daily content');
    }
  }
);
